import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fechamento-consulta`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        getMedicoes(id) {
            return repository.get(`${baseUrl}/medicao/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {
            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {
            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getEspecialidadesWithJornada(queryParms) {
            return repository.get(`${baseUrl}/especialidade-jornada?${urlUtil.serialize(queryParms)}`)
        },
        getUsuariosWithJornada(queryParms) {
            return repository.get(`${baseUrl}/usuario-jornada?${urlUtil.serialize(queryParms)}`)
        },
    }
}